import { useAtomValue } from "jotai";
import { getNotificationExcludedTypes } from "shared/getNotificationExcludedTypes";
import { useRemindersRightOptional } from "web_myplann/Api/Rights/RightsProvider";
import { NotificationTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import { rightsState } from "web_myplann/Shared/State/rightsAtom";

export const useNotificationExcludedTypes = (): {
	excludedTypes: NotificationTypeEnum[] | undefined;
	isReady: boolean;
} => {
	const hasRemindersRight = useRemindersRightOptional();
	const isPending = useAtomValue(rightsState) === undefined;

	return {
		excludedTypes: getNotificationExcludedTypes(hasRemindersRight)?.map(
			(type) => NotificationTypeEnum[type],
		),
		isReady: !isPending,
	};
};
